export const __ONE__ = 1
export const __TWO__ = 2
export const __THREE__ = 3
export const __TEN__ = 10

export const __PLUS_TWENTY_PERCENT__ = 1.2
export const __LESS_FIVE_PERCENT__ = 0.95

export const __RADIX_16__ = 16

export const __MICRO_ALGO_RATIO__ = 1000000
export const __EIGHT_DIGITS__ = 8

export const __ONE_SECOND__ = 1000
export const __TWO_SECONDS__ = 2000
export const __TEN_SECONDS__ = 10000
export const __ONE_MINUTE__ = 60000

export const __USER_REJECTED_THE_REQUEST__ = 4001

// Truncate
export const __MAX_ELEMENTS__ = 12
